<ng-container *ngIf="timeAgo$ | async as timeAgo; else fallbackMsg">
  <span [attr.title]="timestamp | datez: null">{{ timeAgo }}</span>
</ng-container>
<ng-template #fallbackMsg>
  {{ missingTimestampLabel }}
</ng-template>
